export default function splitLocale(locale) {
  if (!locale) {
    return {language: null, region: null};
  }

  if (!locale.includes('-')) {
    return {language: locale, region: null};
  }

  const [language, region = null] = locale.split('-');
  return {language, region};
}
